import { z } from 'zod';

export const DatiqCellTitleSchema = z.object({
    label: z.string(),
    data: z.unknown().optional(),
});

export interface IDatiqCellTitle extends z.infer<typeof DatiqCellTitleSchema> {}
